export const BREAKPOINT_MOBILE = 0;
export const BREAKPOINT_TABLET = 768;
export const BREAKPOINT_DESKTOP = 1025;
export const MAX_CONTENT_WIDTH = 1200;
export const IS_IOS_SAFARI = /iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent));
export const IS_INTERNET_EXPLORER = /Trident\//i.test(window.navigator.userAgent);
